import React from 'react';

const ClassManager = () => {
  return (
    <div>
      <h1>Gestion des Classes</h1>
      {/* Contenu de gestion des classes */}
    </div>
  );
};

export default ClassManager;